import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/LogoPng.png';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [revealLinks, setRevealLinks] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const toggleRef = useRef(null);
    const firstLinkRef = useRef(null);
    const logoTimerRef = useRef(null);
    const focusTimerRef = useRef(null);
    const closeTimerRef = useRef(null);

    // When the route changes, close the menu after a short delay so the
    // new page has time to render. This keeps the overlay visible during
    // navigation for a smoother transition.
    useEffect(() => {
        // only schedule a close if the menu is currently open
        if (!menuOpen) return;
        // clear any existing close timer first
        if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
        // close quickly once the new page loads
        closeTimerRef.current = setTimeout(() => {
            setMenuOpen(false);
            setRevealLinks(false);
        }, 300);
        return () => {
            if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
        };
    }, [location.pathname]);

    // focus management & escape-to-close
    useEffect(() => {
        function onKey(e) {
            if (e.key === 'Escape') setMenuOpen(false);
        }

        // Clear timers on re-run
        if (logoTimerRef.current) {
            clearTimeout(logoTimerRef.current);
            logoTimerRef.current = null;
        }
        if (focusTimerRef.current) {
            clearTimeout(focusTimerRef.current);
            focusTimerRef.current = null;
        }

        if (menuOpen) {
            // Start two-stage reveal: first show logo, then reveal links
            setRevealLinks(false);
            const LOGO_DURATION = 220; // shorter: links reveal faster
            // After logo animation, reveal links
            logoTimerRef.current = setTimeout(() => {
                setRevealLinks(true);
            }, LOGO_DURATION);

            // Focus first link shortly after links reveal for accessibility
            focusTimerRef.current = setTimeout(() => {
                firstLinkRef.current?.focus();
            }, LOGO_DURATION + 80);

            document.addEventListener('keydown', onKey);
        } else {
            // return focus to toggle button
            toggleRef.current?.focus();
            setRevealLinks(false);
            document.removeEventListener('keydown', onKey);
        }

        return () => {
            document.removeEventListener('keydown', onKey);
            if (logoTimerRef.current) clearTimeout(logoTimerRef.current);
            if (focusTimerRef.current) clearTimeout(focusTimerRef.current);
        };
    }, [menuOpen]);

    // Navigate programmatically: if clicking the link for the current
    // page, force a reload so the page updates; otherwise push a new
    // route and let the location-change handler close the menu.
    function handleNavigate(path) {
        // always close the menu immediately for responsiveness
        setMenuOpen(false);
        setRevealLinks(false);

        if (location.pathname === path) {
            // same page: force a reload
            // use replace to avoid polluting history with the same path
            // then reload to refresh content
            history.replace(path);
            // small delay to allow the menu to close visually before reload
            setTimeout(() => window.location.reload(), 120);
        } else {
            history.push(path);
        }
    }

    return (
        <header className="home-header">
            <div className="header-logo">
                <img src={logo} alt="Logo HART ÉLÉGANCE" className="main-logo small" />
            </div>
            <button
                ref={toggleRef}
                className="menu-toggle"
                aria-expanded={menuOpen}
                aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
                onClick={() => setMenuOpen(!menuOpen)}
            >
                {menuOpen ? <FaTimes /> : <FaBars />}
            </button>

         <nav className={`home-nav ${menuOpen ? 'open' : ''}`} aria-hidden={!menuOpen}>
             <div className={`nav-overlay ${menuOpen ? 'enter' : 'exit'} ${revealLinks ? 'reveal' : ''}`} aria-hidden={!menuOpen}>
                    <ul className="nav-text-links" role="menu">
                        <li role="none"><button ref={firstLinkRef} className="menu-link" onClick={() => handleNavigate('/')}>ACCUEIL</button></li>
                        <li role="none"><button className="menu-link" onClick={() => handleNavigate('/about-us')}>LA MAISON</button></li>
                        <li role="none"><button className="menu-link" onClick={() => handleNavigate('/expertises')}>EXPERTISES</button></li>
                        <li role="none"><button className="menu-link" onClick={() => handleNavigate('/collections')}>COLLECTIONS</button></li>
                        <li role="none"><button className="menu-link" onClick={() => handleNavigate('/ma-lux-pensee')}>MA LUX PENSÉE <span className="nav-subtitle">Rubrique éditoriale et philosophique</span></button></li>
                        <li role="none"><button className="menu-link" onClick={() => handleNavigate('/contact')}>CONTACT <span className="nav-subtitle">Demande d’Entretien Stratégique Confidentiel</span></button></li>
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default Header;